<template>
    <div class="cs-multi-column-text cs-block" :class="styleClass">
        <div class="cs-block-base" :class="rootClasses">
            <div class="container">
                <div class="header-content">
                    <ColorSplit class="cs-title" :data="data.title" />
                    <h3 class="cs-sub-title" v-html="data.subTitle"></h3>
                </div>
                <div class="row">
                    <div
                        class="column"
                        v-for="(item, key) in data.textList"
                        :key="key"
                    >
                        <span class="cs-text" v-html="item.text"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MulticolumnText',
    props: {
        data: {
            type: Object,
            default: () => {}
        }
    },
    components: {
        ColorSplit: () => import("../blocks_components/ColorSplit.vue"),
    },
    data() {
        return {}
    },
    computed: {
        styleClass(){
            let result = ''

            if(this.data.style) result += ` cs-style-${this.data.style}`;

            return result
        },
        rootClasses() {
            let result = ''

            if(this.data.columns) result += ` cs-distribution-${this.data.columns}`;

            return result
        }
    }
}
</script>
<style lang="scss" scoped>
@import '../styles/main.scss';
.cs-multi-column-text {
    display: flex;
    justify-content: center;

    &.cs-style- {
        &color {
            @include cs-block-color;
            .cs-sub-title{
                color:$sub_title_color;
            }
        *, ::v-deep *{
                color:white;
            }
        }

        &light {
            @include cs-block-light;
            .cs-sub-title{
                color: $sub_title_color_light;
            }
        }

        &dark {
            @include cs-block-dark;

            .cs-sub-title{
                color: $sub_title_color_dark;
            }
        }
    }

    .cs-block-base {
        .header-content {
            z-index: 20;
            position: relative;
            text-align: center;
            margin-bottom: $header_margin !important;
            
            &:last-child {
                margin-bottom: 0 !important;
            }
    
            .cs-title {
                @include title;
                margin-bottom: 20px;
            }
        }
        .row {
            padding: 0px 20px;
            flex-wrap: nowrap;
            gap: 30px;
            @media screen and (max-width: 768px) {
                flex-direction: column;
            }
            .column {
                @include text;
                text-align: left;
                p {
                    color: #fff
                }
            }
        }
    }
}
</style>